import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

interface RequirePermissionProps {
  perm: string
  children: React.ReactNode
}

const RequirePermission: React.FC<RequirePermissionProps> = ({ perm, children }) => {
  const { loading, hasPermission } = useAuth()
  if (loading) return null
  if (!hasPermission(perm)) return <Navigate to="/" replace />
  return <>{children}</>
}

export default RequirePermission


